import Cookies from "js-cookie";
import { BUSSINESS_NAME } from "../appsetting";
import { AuthCheck } from "./Helper";

export const callApi = async (url, options, logout) => {
  const token = localStorage.getItem(BUSSINESS_NAME + '_token');
  let headers = {};
  if (options?.data && !(options?.data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  
  try {
    const raw = await fetch(url, {
      headers: {
        ...(token &&
          token !== undefined && { Authorization: `Bearer ${token}` }),
        ...headers,
        // "Content-Type": "application/json",
      },
      method: options?.method || "GET",
      body: options?.data instanceof FormData ? options?.data : JSON.stringify(options?.data),
    });

    const data = await raw.json();

    if (!raw.ok) {
      if (raw.status == 401) {
        logout();
        return;
        const newToken = await AuthCheck();

        const retryResponse = await fetch(url, {
          method: options?.method || "GET",
          headers: {
            Authorization: `Bearer ${newToken}`,
            "Content-Type": options?.formData
              ? "multipart/form-data"
              : "application/json",
          },
          body: options?.formData
            ? options?.data
            : options?.data
            ? JSON.stringify(options?.data)
            : undefined,
        });
        const responseData = await retryResponse.json();
        return responseData;
      }else if (raw.status === 403) {
        window.location.href = "/not-found"; // or use your actual route path
        return; // stop execution
      }
      throw new Error(data.message);
    }
    return data;
  } catch (error) {
    return error;
  } finally {
  }
};

export const POST_DATA_HEADEERS = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + Cookies.get("accessToken"),
};
